import { v4 as uuid } from 'uuid';

export const normalizeItems = (items = []) =>
    items.map(item => ({
        '@id': item['@id'] || uuid(),
        ...item,
    }));